import { HttpErrorResponse } from '@angular/common/http';
import {
    Attribute,
    AttributeType, Brand, Category, ConfigureData, Country, DateRange, DynamicExchangeRate, Extraction, ExtractionMutated, FileTypes, FilterTypes, MinMaxRange, Promotion, Retailer, RetailerType, SubBrand, Supplier, TotalSKUSizeRange
} from '@emi/shared/models';
import { createAction, props } from '@ngrx/store';

export const getExtractions = createAction('[Extractions] Get Extractions');

export const postExtractions = createAction('[ExtractionCreation] post Extractions');

export const postExtractionsSuccess = createAction('[ExtractionCreation] Post Extractions');

export const getExtractionsSuccess = createAction('[Extractions] Get Extractions Success', props<{ extractions: Extraction[] }>());

export const getExtractionsFailure = createAction('[Extractions] Get Extractions Failure', props<{ error: HttpErrorResponse }>());

export const addConfigureDataSelection = createAction(
    '[ExtractionCreation] Update configuration selection',
    props<{ configureData: ConfigureData }>()
);

export const fetchExtractions = createAction('[Extractions] Fetch Extractions');

export const isLoadingExtractions = createAction('[Extractions] Loading Extractions');

export const navigateToFilters = createAction('[Extractions] NavigateToFilters', props<{ extractionId: number }>());

export const getFilterSelections = createAction('[Extractions] Get Filter Selections', props<{ extraction: ExtractionMutated }>());

export const getFiltersFailure = createAction(
    '[Extractions] Get Filter Selections Failure',
    props<{ error: HttpErrorResponse; filterType: FilterTypes }>()
);

export const getFilterNames = createAction('[Extractions] Get Filter Names for Extraction', props<{ extraction: ExtractionMutated }>());

export const getFilterNamesSuccess = createAction(
    '[Extractions] Get Filter Names Success',
    props<{ names: string[]; extractionId: number; filterType: FilterTypes }>()
);

export const getFilterNamesFailure = createAction(
    '[Extractions] Get Filter Names Failure',
    props<{ error: HttpErrorResponse; filterType: FilterTypes }>()
);

export const isLoadingExtractionFilterNames = createAction(
    '[Extractions] Loading Extraction Filter Names',
    props<{ extractionId: number; isLoading: boolean }>()
);

export const clearSelections = createAction('[ExtractionCreation] Clear previous selections');

export const addTitleInput = createAction('[ExtractionCreation] Update title typed in', props<{ title: string }>());

export const addDescriptionInput = createAction('[ExtractionCreation] Update description typed in', props<{ description: string }>());

export const getCountriesFiltersSuccess = createAction('[Extractions] Get countries filters success', props<{ countries: Country[] }>());

export const getCategoriesFiltersSuccess = createAction(
    '[Extractions] Get categories filters success',
    props<{ categories: Category[] }>()
);

export const getBrandsFiltersSuccess = createAction('[Extractions] Get brands filters success', props<{ brands: Brand[] }>());

export const getSuppliersFiltersSuccess = createAction('[Extractions] Get suppliers filters success', props<{ suppliers: Supplier[] }>());

export const getAttributeFiltersSuccess = createAction(
    '[Extractions] Get attributes filters success',
    props<{ attributes: Attribute[] }>()
);

export const getAttributeTypeFiltersSuccess = createAction(
    '[Extractions] Get attributeTypes filters success',
    props<{ attributeTypes: AttributeType[] }>()
);

export const getRetailerFiltersSuccess = createAction('[Extractions] Get retailers filters success', props<{ retailers: Retailer[] }>());

export const getRetailerTypeFiltersSuccess = createAction(
    '[Extractions] Get retailerTypes filters success',
    props<{ retailerTypes: RetailerType[] }>()
);

export const getPromotionFiltersSuccess = createAction('[Extractions] Get promotion filters success', props<{ promotions: Promotion[] }>());

export const addCountriesSelection = createAction('[CountryFilters] Update countries selections', props<{ countries: Country[] }>());
export const addCategoriesSelection = createAction('[CategoryFilters] Update categories selections', props<{ categories: Category[] }>());
export const addCategoriesSuggestionSelection = createAction('[CategoryFilters] Update categories suggestion selections', props<{ categories: Category[] }>());

export const getSubCategoriesSelectionSuccess = createAction('[CategoryFilters] Get sub categories selection success', props<{ categories: Category[] }>());

export const addBrandsSelection = createAction('[BrandFilters] Update brands selections', props<{ brands: Brand[] }>());
export const addBrandsSuggestionSelection = createAction('[BrandFilters] Update brands suggestion selections', props<{ brands: Brand[] }>());
export const addSubBrandsSuggestionSelection = createAction('[BrandFilters] Update sub brands selections', props<{ subBrands: SubBrand[]; }>());
export const getSubBrandsSelectionSuccess = createAction('[BrandFilters] Get brands selection success', props<{ brands: Brand[] }>());

export const addSuppliersSelection = createAction('[SupplierFilters] Update suppliers selections', props<{ suppliers: Supplier[] }>());

export const addAttributeSelection = createAction('[AttributeFilters] Update attributes selections', props<{ attributes: Attribute[] }>());

export const addAttributeTypeSelection = createAction(
    '[AttributeTypeFilters] Update attributeTypes selections',
    props<{ attributeTypes: AttributeType[] }>()
);

export const addRetailerSelection = createAction('[RetailerFilters] Update retailers selections', props<{ retailers: Retailer[] }>());

export const addRetailerTypeSelection = createAction(
    '[RetailerTypeFilters] Update retailerTypes selections',
    props<{ retailerTypes: RetailerType[] }>()
);

export const addPromotionSelection = createAction('[PromotionFilters] Update promotion selections', props<{ promotions: Promotion[] }>());

export const addFirstSeenPriceRangeSelection = createAction('[DateRangePriceSKUSizeFilters] Update First Seen Price Range Min & Max selections', props<{ firstSeenPriceRange: MinMaxRange | null }>());

export const addLastSeenPriceRangeSelection = createAction('[DateRangePriceSKUSizeFilters] Update Last Seen Price Range Min & Max selections', props<{ lastSeenPriceRange: MinMaxRange | null }>());

export const addDateRangeSelection = createAction('[DateRangePriceSKUSizeFilters] Update Date Range Start & End selections', props<{ dateRange: DateRange | null }>());

export const addVolumeRangeSelection = createAction('[DateRangePriceSKUSizeFilters] Update Volume Range Min & Max selections', props<{ volumeRange: TotalSKUSizeRange | null }>());

export const addWeightRangeSelection = createAction('[DateRangePriceSKUSizeFilters] Update Weight Range Min & Max selections', props<{ weightRange: TotalSKUSizeRange | null }>());

export const addCountRangeSelection = createAction('[DateRangePriceSKUSizeFilters] Update Count Range Min & Max selections', props<{ countRange: TotalSKUSizeRange | null }>());

export const isLoadingSelections = createAction('[Filters] Loading selections', props<{ isLoading: boolean }>());

export const deleteExtractions = createAction('[Extractions] Delete Extractions', props<{ extractionId: number }>());

export const deleteExtractionsSuccess = createAction('[Extractions] Delete Extractions successful', props<{ extractionId: number }>());

export const deleteExtractionsFailure = createAction('[Extractions] Delete Extractions Failure', props<{ error: HttpErrorResponse }>());

export const downloadExtraction = createAction(
    '[Extractions] Download Extraction',
    props<{ extractionId: number; extractionName: string; fileType: FileTypes; includeAttributesFile: boolean }>()
);

export const downloadExtractionSuccess = createAction('[Extractions] Download Extraction successful', props<{ extractionId: number }>());

export const downloadExtractionsFailure = createAction(
    '[Extractions] Download Extractions Failure',
    props<{ error: HttpErrorResponse; extractionId: number }>()
);
export const getExchangeRates = createAction('[ExchangeRates] Get ExchangeRates', props<{ currency: string }>());

export const getExchangeRatesSuccess = createAction('[Extractions] Get Exchange rates success', props<{ exchangeRates: DynamicExchangeRate[] }>());

export const updateReloadedExtraction = createAction('[Extractions] Update Reloaded Extraction', props<{ reloadedExtraction: ExtractionMutated }>());

export const updateDefaultDateRange = createAction('[Filters] Update default date range', props<{ defaultDateRange: DateRange }>());
